
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.833 15c-1.524.343-2.5.87-2.5 1.461 0 1.034 2.985 1.872 6.667 1.872s6.667-.838 6.667-1.872c0-.59-.976-1.118-2.5-1.461","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M12.083 7.5a2.083 2.083 0 11-4.166 0 2.083 2.083 0 014.166 0z","stroke":"#fff","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M11.048 14.578a1.51 1.51 0 01-2.096 0c-2.573-2.494-6.023-5.28-4.34-9.325C5.52 3.066 7.703 1.667 10 1.667s4.48 1.4 5.389 3.586c1.68 4.04-1.761 6.84-4.341 9.325z","stroke":"#fff","stroke-width":"1.5"}})])
          )
        }
      }
    